import React, { Component } from 'react';
import Slide from './SlickCarousel';
import NavigateToWebApps from '../../../utils/NavigateToWebApps';
import envConfig from '../../../../static/config';
import { isMTrackTileEnabled } from '../../homepage/HomepageTilesUtils';
import MTrackStore from '../../../stores/MTrackStore';
import StringConstants from '../../../constants/StringConstants';

class BusinessPromotionalComponent extends Component {
  constructor(props) {
    super(props);
    this.onTileClick = this.onTileClick.bind(this);
  }

  getBPTileData(tile, content) {
    const tileData = {
      id: tile,
      title: '',
      text: '',
      btnLabel: '',
    };

    switch (tile) {
      case StringConstants.debitCard:
        tileData.title = content.debitCardTitle;
        tileData.text = content.debitCardTileText;
        tileData.btnLabel = content.debitCardTileBtnLabel;
        break;
      case StringConstants.mTrack:
        tileData.title = content.mTrackTitle;
        tileData.text = content.mTrackTileText;
        tileData.btnLabel = content.closerLook;
        break;
      case StringConstants.marketPlace:
        tileData.title = content.marketPlaceTitle;
        tileData.text = content.marketPlaceTileText;
        tileData.btnLabel = content.findOutMore;
        break;
      default:
        break;
    }
    return tileData;
  }
  onTileClick(tile) {
    const {
      accountDetails: { id, accountNumber, sortCode, displayName, accountName },
    } = this.props;
    switch (tile) {
      case StringConstants.debitCard:
        NavigateToWebApps.navigateToDebitCardWebAppPage(
          envConfig.debitCardWebAppLink,
          {
            account_id: id,
            account_number: accountNumber,
            sort_code: sortCode,
            account_name: accountName,
            display_name: displayName,
          }
        );
        break;
      case StringConstants.mTrack:
        NavigateToWebApps.navigateToBrochurewarePage(
          envConfig.mTrackBrochurewareLink,
          true
        );
        break;
      case StringConstants.marketPlace:
        NavigateToWebApps.navigateTo(envConfig.marketplaceLink);
        break;
      default:
        return;
    }
  }

  getTilesData() {
    const businessPromoDataList = [];
    businessPromoDataList.push(
      this.getBPTileData(StringConstants.debitCard, this.props.content)
    );
    if (isMTrackTileEnabled() && MTrackStore.isMTrackConsented() === false) {
      businessPromoDataList.push(
        this.getBPTileData(StringConstants.mTrack, this.props.content)
      );
    }
    if (envConfig.isMarketplaceEnabled) {
      businessPromoDataList.push(
        this.getBPTileData(StringConstants.marketPlace, this.props.content)
      );
    }
    return businessPromoDataList;
  }

  render() {
    return (
      <Slide
        {...this.props}
        onTileClick={this.onTileClick}
        slides={this.getTilesData()}
        isBusinessPromo={true}
      />
    );
  }
}

BusinessPromotionalComponent.defaultProps = {
  content: '',
};

export default BusinessPromotionalComponent;
